var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 1 } },
        [_vm._t("status")],
        2
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 2 } },
        [_vm._t("set")],
        2
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 1 } },
        [
          _c(
            "v-card",
            { staticClass: "fill-height", attrs: { tile: "", flat: "" } },
            [_vm._t("id")],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 3 } },
        [
          _c(
            "v-card",
            { staticClass: "fill-height", attrs: { tile: "", flat: "" } },
            [_vm._t("title")],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 1 } },
        [
          _c(
            "v-card",
            { staticClass: "fill-height", attrs: { tile: "", flat: "" } },
            [_vm._t("severity")],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 2 } },
        [
          _c(
            "v-card",
            { staticClass: "fill-height", attrs: { tile: "", flat: "" } },
            [_vm._t("tags")],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 1 } },
        [
          _c(
            "v-card",
            { staticClass: "fill-height", attrs: { tile: "", flat: "" } },
            [_vm._t("runTime")],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { align: "center", cols: 1 } },
        [
          _c(
            "v-card",
            {
              staticClass: "fill-height text-center",
              attrs: { tile: "", flat: "" },
            },
            [_vm._t("viewed")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }